export default __webpack_public_path__ + "static/media/LandingPage_Banner_POS.4365812a.png";